import ExcelJS from "exceljs";

// ============================================================
// DISTRICT → TALUKA MAPPING
// ============================================================

export const districtTalukaMap = {
  "अकोला": [
    "अकोट",
    "अकोला",
    "तेल्हारा",
    "पातुर",
    "बार्शी टाकळी",
    "बाळापुर",
    "मुर्तिजापूर"
  ],

  "अमरावती": [
    "अचलपूर",
    "अंजनगाव सुर्जी",
    "अमरावती",
    "चांदूर रेल्वे",
    "चांदूरबाजार",
    "चिखलदरा",
    "तिवसा",
    "दर्यापूर",
    "धामणगाव",
    "धारणी",
    "नांदगाव खंडेश्वर",
    "भातकुली",
    "मोर्शी",
    "वरुड"
  ],

  "अहिल्यानगर": [
    "अकोले",
    "अहिल्यानगर",
    "कर्जत - अहमदनगर",
    "कोपरगाव",
    "नेवासा",
    "पाथर्डी",
    "पारनेर",
    "राहता पिम्पळस",
    "राहुरी",
    "शेवगाव",
    "श्रीगोंदा",
    "श्रीरामपूर",
    "संगमनेर"
  ],

  "बीड": [
    "अंबाजोगाई",
    "आष्टी - बीड",
    "केज",
    "गेवराई",
    "धारूर",
    "परळी वैजनाथ",
    "पाटोदा",
    "बीड",
    "माजलगाव",
    "वडवणी",
    "शिरूर कासार"
  ],

  "बुलढाणा": [
    "खामगाव",
    "चिखली",
    "जळगाव जामोद",
    "देऊळगाव राजा",
    "नांदुरा",
    "बुलडाणा",
    "मलकापूर बुलढाणा",
    "मेहकर",
    "मोताळा",
    "लोणार",
    "शेगाव",
    "संग्रामपूर",
    "सिंदखेडराजा"
  ],

  "वाशिम": [
    "कारंजा",
    "मंगरूळपीर",
    "मानोरा",
    "मालेगाव - वाशिम",
    "रिसोड",
    "वाशिम"
  ],

  "यवतमाळ": [
    "आर्णी",
    "उमरखेड",
    "कळंब",
    "केळापूर",
    "घटांजी",
    "जरी जमनी",
    "दारव्हा",
    "दिग्रस",
    "नेर- नवापूर",
    "पुसद",
    "बाभुळगाव",
    "महागाव",
    "मारेगाव",
    "यवतमाळ",
    "राळेगाव",
    "वणी"
  ],

  "छत्रपती संभाजीनगर": [
    "कन्नड",
    "खुलताबाद",
    "गंगापूर",
    "छत्रपती संभाजीनगर",
    "पैठण",
    "फुलंब्री",
    "वैजापूर",
    "सिल्लोड",
    "सोयगाव"
  ],

  "धाराशिव": [
    "उमरगा",
    "कळंब",
    "तुळजापूर",
    "धाराशिव",
    "परांडा",
    "भुम",
    "लोहारा",
    "वाशी"
  ],

  "हिंगोली": [
    "औंढा नागनाथ",
    "कळमनुरी",
    "बसमत नगर",
    "सेनगाव",
    "हिंगोली"
  ],

  "जालना": [
    "आंबड",
    "घनसावंगी",
    "जाफ्राबाद",
    "जालना",
    "परतूर",
    "बदनापूर",
    "भोकरदन",
    "मंठा"
  ],

  "लातूर": [
    "अहमदपूर",
    "उदगीर",
    "औसा",
    "चाकूर",
    "जळकोट",
    "देवणी",
    "निलंगा",
    "रेणापूर",
    "लातूर",
    "शिरूर अनंतपाळ"
  ],

  "नांदेड": [
    "अर्धापूर",
    "उमरी",
    "कंधार",
    "किनवट",
    "देगलूर",
    "धर्माबाद",
    "नांदेड",
    "नायगाव",
    "बिलोली",
    "भोकर",
    "माहूर",
    "मुखेड",
    "मुदखेड",
    "लोहा",
    "हदगाव",
    "हिमायतनगर"
  ],

  "परभणी": [
    "गंगाखेड",
    "जिंतूर",
    "परभणी",
    "पाथरी",
    "पालम",
    "पूर्णा",
    "मानवत",
    "सेलू",
    "सोनपेठ"
  ],

  "पालघर": [
    "जव्हार",
    "डहाणू",
    "तलासरी",
    "पालघर",
    "मोखाडा",
    "वसई विरार",
    "वाडा",
    "विक्रमगड"
  ],

  "रायगड": [
    "अलिबाग (जी.मु.)",
    "उरण",
    "कर्जत",
    "खालापूर",
    "खोपोली",
    "तळा",
    "पनवेल",
    "पेण",
    "पोलादपूर",
    "महाड",
    "माणगाव",
    "माथेरान",
    "मुरुड जंजिरा",
    "म्हसाळा",
    "रोहा",
    "श्रीवर्धन",
    "सुधागड-पाली"
  ],

  "रत्नागिरी": [
    "खेड",
    "गुहागर",
    "चिपळूण",
    "दापोली",
    "देवरुख",
    "मंडणगड",
    "रत्नागिरी",
    "राजापूर",
    "लांजा"
  ],

  "सिंधुदुर्ग": [
    "कणकवली",
    "कसाई - दोडामार्ग",
    "कुडाळ",
    "देवगड जामसंडे",
    "मालवण",
    "वाभावे - वैभववाडी",
    "वेंगुर्ला",
    "सावंतवाडी (जी.मु.)"
  ],

  "ठाणे": [
    "अंबरनाथ",
    "कल्याण",
    "ठाणे",
    "भिवंडी",
    "मुरबाड",
    "शहापूर"
  ],

  "भंडारा": [
    "तुमसर",
    "पवनी",
    "भंडारा",
    "मोहाडी",
    "लाखनी",
    "लाखांदूर",
    "साकोली"
  ],

  "चंद्रपूर": [
    "कोरपना",
    "गोंडपिपरी",
    "चंद्रपूर",
    "चिमूर",
    "जिवती",
    "नागभीड",
    "पोंभुर्णा",
    "बल्लारपूर",
    "ब्रम्हपुरी",
    "भद्रावती",
    "मुल",
    "राजुरा",
    "वरोरा",
    "सावली",
    "सिंदेवाही"
  ],

  "गडचिरोली": [
    "आरमोरी",
    "आहेरी",
    "एटापल्ली",
    "कुरखेडा",
    "कोर्ची",
    "गडचिरोली",
    "चामोर्शी",
    "देसाईगंज",
    "धानोरा",
    "भामरागड",
    "मुलचेरा",
    "सिरोंचा"
  ],

  "गोंदिया": [
    "अर्जुनी मोरगाव",
    "आमगाव",
    "गोंदिया",
    "गोरेगाव",
    "तीरोरा",
    "देवरी",
    "सडक - अर्जुनी",
    "सालेकसा"
  ],

  "नागपूर": [
    "उमरेड",
    "कळमेश्वर",
    "काटोल",
    "कामठी",
    "कुही",
    "नरखेड",
    "नागपूर ग्रामीण",
    "नागपूर शहरी",
    "पारशिवनी",
    "भिवापूर",
    "मौदा",
    "रामटेक",
    "सावनेर",
    "हिंगणा"
  ],

  "वर्धा": [
    "आर्वी",
    "आष्टी - वर्धा",
    "कारंजा - वर्धा",
    "देवळी",
    "वर्धा",
    "समुद्रपूर",
    "सेलू - वर्धा",
    "हिंगणघाट"
  ],

  "अहिल्यानगर-उत्तर": [
    "अकोले",
    "कोपरगाव",
    "राहता पिम्पळस",
    "राहुरी",
    "श्रीरामपूर",
    "संगमनेर"
  ],

  "अहिल्यानगर-दक्षिण": [
    "अहिल्यानगर",
    "कर्जत",
    "जामखेड",
    "पाथर्डी",
    "पारनेर",
    "शेवगाव",
    "श्रीगोंदा"
  ],

  "धुळे": [
    "धुळे",
    "शिरपूर वरवडे",
    "साक्री",
    "सिंदखेडा"
  ],

  "जळगाव": [
    "अमळनेर",
    "एरंडोल",
    "चाळीसगाव",
    "चोपडा",
    "जळगाव",
    "जामनेर",
    "धरणगाव",
    "पाचोरा",
    "पारोळा",
    "बोदवड",
    "भडगाव",
    "भुसावळ",
    "मुक्ताईनगर",
    "यावल",
    "रावेर"
  ],

  "नंदुरबार": [
    "अक्कलकुवा",
    "तळोदा",
    "नंदुरबार",
    "नवापुर",
    "शहादा"
  ],

  "नाशिक": [
    "इगतपुरी",
    "कळवण",
    "चांदवड",
    "त्रिंबक",
    "दिंडोरी",
    "देवळा",
    "नांदगाव",
    "नाशिक",
    "निफाड",
    "पेठ",
    "बागलाण",
    "मालेगाव",
    "येवला",
    "सिन्नर",
    "सुरगाणा"
  ],

  "कोल्हापूर": [
    "अजरा",
    "करवीर",
    "कागल",
    "कोल्हापूर",
    "गडहिंग्लज",
    "चंदगड",
    "पन्हाळा",
    "भुदरगड",
    "राधानगरी",
    "शाहूवाडी",
    "शिरोळ",
    "हातकंगले"
  ],

  "पुणे": [
    "आंबेगाव",
    "इंदापूर",
    "खेड",
    "जुन्नर",
    "दौंड",
    "पुरंदर",
    "बारामती",
    "भोर",
    "मावळ",
    "मुळशी",
    "वेल्हे",
    "शिरूर",
    "हवेली"
  ],

  "सांगली": [
    "आटपाडी",
    "आष्टा",
    "इस्लामपूर",
    "कडेगाव",
    "कवठे महांकाळ",
    "खानापूर",
    "जत",
    "तासगाव",
    "पलूस",
    "विटा",
    "शिराळा",
    "सांगली मिरज"
  ],

  "सातारा": [
    "कराड",
    "कोरेगाव",
    "खटाव (वडूज)",
    "खंडाळा",
    "जावळी",
    "पाटण",
    "फलटण",
    "महाबळेश्वर",
    "माण (दहिवडी)",
    "वाई",
    "सातारा"
  ],

  "सोलापूर": [
    "अक्कलकोट",
    "उत्तर सोलापूर",
    "करमाळा",
    "दक्षिण सोलापूर",
    "पंढरपूर",
    "बार्शी",
    "मंगळवेढा",
    "माढा",
    "माळशिरस",
    "मोहोळ",
    "सांगोला"
  ],

  "पुणे-उत्तर": [
    "आंबेगाव",
    "खेड",
    "जुन्नर",
    "भोर",
    "मावळ",
    "मुळशी",
    "वेल्हे"
  ],

  "पुणे-दक्षिण": [
    "इंदापूर",
    "दौंड",
    "पुरंदर",
    "बारामती",
    "शिरूर",
    "हवेली"
  ],

  "यवतमाळ-कार्य विभाग 1": [
    "कळंब",
    "मारेगाव",
    "यवतमाळ",
    "राळेगाव",
    "वणी"
  ],

  "सोलापूर-कार्य विभाग 1": [
    "अक्कलकोट",
    "उत्तर सोलापूर",
    "दक्षिण सोलापूर",
    "बार्शी",
    "माढा",
    "मोहोळ"
  ],

  "सोलापूर-कार्य विभाग 2": [
    "करमाळा",
    "पंढरपूर",
    "मंगळवेढा",
    "माळशिरस",
    "सांगोला"
  ],

  "सातारा-उत्तर": [
    "कोरेगाव",
    "खंडाळा",
    "फलटण",
    "महाबळेश्वर",
    "वाई",
    "सातारा"
  ],

  "सातारा-दक्षिण": [
    "कराड",
    "खटाव (वडूज)",
    "जावळी",
    "पाटण",
    "माण (दहिवडी)"
  ]
};


// ============================================================
// HELPER: EXCEL COLUMN NAME
// ============================================================

export const getColumnName = (columnNumber) => {
  let columnName = "";

  while (columnNumber > 0) {
    const remainder = (columnNumber - 1) % 26;

    columnName =
      String.fromCharCode(65 + remainder) + columnName;

    columnNumber = Math.floor((columnNumber - 1) / 26);
  }

  return columnName;
};


export const setupDistrictTalukaData = (workbook) => {
  let masterSheet = workbook.getWorksheet("MasterData");

  if (!masterSheet) {
    masterSheet = workbook.addWorksheet("MasterData");
  }

  // Clear existing data
  masterSheet.eachRow((row) => {
    row.eachCell((cell) => {
      cell.value = null;
    });
  });

  // Headers
  masterSheet.getCell("A1").value = "District";
  masterSheet.getCell("B1").value = "RangeName";

 const districts = Object.keys(districtTalukaMap).sort((a, b) =>
  a.localeCompare(b, "mr")
);

  districts.forEach((district, index) => {
    const masterRow = index + 2;

    // District
    masterSheet.getCell(`A${masterRow}`).value = district;

    // Named range name
    const rangeName = `District_${index + 1}`;

    masterSheet.getCell(`B${masterRow}`).value = rangeName;

    // Talukas stored horizontally starting from Column C
    const talukas = districtTalukaMap[district] || [];

    talukas.forEach((taluka, talukaIndex) => {
      const columnNumber = 3 + talukaIndex;

      masterSheet.getCell(
        masterRow,
        columnNumber
      ).value = taluka;
    });

    // Create named range
    if (talukas.length > 0) {
      const firstColumn = "C";

      const lastColumn = getColumnName(
        2 + talukas.length
      );

      const rangeAddress =
        `'MasterData'!$${firstColumn}$${masterRow}:$${lastColumn}$${masterRow}`;

      workbook.definedNames.add(
        rangeAddress,
        rangeName
      );
    }
  });

  // Hide helper sheet
  masterSheet.state = "hidden";

  return {
    districts,
    districtEndRow: districts.length + 1
  };
};

export const applyDistrictTalukaDropdowns = (
  workbook,
  worksheet,
  startRow,
  endRow
) => {
 const districts = Object.keys(districtTalukaMap).sort((a, b) =>
  a.localeCompare(b, "mr")
);
  const districtEndRow = districts.length + 1;

  for (let row = startRow; row <= endRow; row++) {
    // District dropdown
    worksheet.getCell(`D${row}`).dataValidation = {
      type: "list",
      allowBlank: true,
      formulae: [
        `'MasterData'!$A$2:$A$${districtEndRow}`
      ],
      showErrorMessage: true,
      errorTitle: "Invalid District",
      error: "Please select a District from the dropdown."
    };

    // Taluka dropdown depends on selected District
    worksheet.getCell(`E${row}`).dataValidation = {
      type: "list",
      allowBlank: true,
      formulae: [
        `INDIRECT("District_"&MATCH(D${row},MasterData!$A$2:$A$${districtEndRow},0))`
      ],
      showErrorMessage: true,
      errorTitle: "Invalid Taluka",
      error: "Please select a Taluka from the dropdown."
    };
  }
};